import React from "react";

import http from "@/services/http";
import {ICentSopModel, IDuration} from "@cent/sop/models";
import {IAdvancedSop} from "@frac/sop/models";
import {EServerId} from "@shared/models";

import CentExecute from "@cent/sop/info/CentExecute";
import {getDurations} from "@cent/sop/info/Index";
import FracExecute from "@frac/sop/info/FracExecute";

interface IProjectRecordIconProps {
    docId: string;
    project: number;
}

interface IProjectRecordIconState {
    device: string;
    duration?: IDuration;
    id: string;
    sop?: ICentSopModel | IAdvancedSop;
    type: string;
}

class ProjectRecordIcon extends React.PureComponent<
    IProjectRecordIconProps,
    IProjectRecordIconState
> {
    public readonly state: IProjectRecordIconState = {...this.getState()};

    private getState() {
        const {docId} = this.props;
        const [type, id, device] = docId.split("/");

        return {type, id, device};
    }

    public componentDidMount() {
        const {type} = this.state;

        if (type === "centSops" || type === "fracSops") {
            this.retrieve();
        }
    }

    public render() {
        const {duration, sop, type} = this.state;

        if ((type !== "centSops" && type !== "fracSops") || !duration || !sop) {
            return null;
        }

        if (type === "centSops") {
            return (
                <span className="ml-1">
                    <CentExecute iconOnly={true} sop={sop as ICentSopModel} />
                </span>
            );
        } else if (type === "fracSops") {
            return (
                <span className="ml-1">
                    <FracExecute iconOnly={true} sop={sop as IAdvancedSop} />
                </span>
            );
        }
    }

    private async retrieve() {
        const {project} = this.props;
        const {id, type} = this.state;
        const serverApi = type.includes("frac")
            ? EServerId.Fracture
            : EServerId.Centrifuge;

        try {
            const response = await http
                .get(`/api/${serverApi}/sop/${project}/${id}`)
                .json<ICentSopModel>();

            let duration: IDuration = {cycles: [], total: 0};
            if (type === "centSops") {
                duration = getDurations(
                    response.cycles,
                    response.channels.length,
                    response.wavelengths.length,
                    response.device.deviceClass,
                );
            }

            this.setState({sop: response, duration});
        } catch (error) {
            this.setState({sop: undefined, duration: undefined});
        }
    }
}

export default ProjectRecordIcon;
